// extracted by mini-css-extract-plugin
export var important = "important-msg-module--important--pDn9j";
export var importantlink = "important-msg-module--importantlink--cG4dB";
export var importanttxt = "important-msg-module--importanttxt--w1dg0";